module.exports = __webpack_public_path__ + "static/media/pricing-33.8c707c7e.png";